import { createAction, props } from '@ngrx/store';
import { IProductSolutionForProductRequest } from '../models/product-solutions-for-product.model';

export const loadProductSolutionsForProducts = createAction(
  '[ProductSolutionsForProduct] Load ProductSolutionsForProducts',
  props<{ productId: string; businessId: string; request: IProductSolutionForProductRequest; isAdded: boolean; isRemoved: boolean }>()
);

export const loadProductSolutionsForProductsSuccess = createAction(
  '[ProductSolutionsForProduct] Load ProductSolutionsForProducts Success',
  props<{ response: string }>()
);

export const loadProductSolutionsForProductsFailure = createAction(
  '[ProductSolutionsForProduct] Load ProductSolutionsForProducts Failure',
  props<{ error: Error | any }>()
);
